
/* ==========================================
   KAROO BABA — STABLE DESKTOP HOVER MENU
   ========================================== */

(() => {
  if (window.karooMegaHoverInitialized) return;
  window.karooMegaHoverInitialized = true;

  const desktop = window.matchMedia('(min-width: 1001px)');
  const CLOSE_DELAY = 350;

  let closeTimer = null;

  function cancelClose() {
    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }
  }

  function closeMenu(details) {
    if (!details || !details.open) return;

    const summary = details.querySelector('summary');

    if (summary) {
      summary.click();
    }
  }

  function openMenu(details) {
    if (!details || details.open) return;

    const summary = details.querySelector('summary');

    if (summary) {
      summary.click();
    }
  }

  document.addEventListener('pointerover', (event) => {
    if (!desktop.matches || event.pointerType !== 'mouse') return;

    const details = event.target.closest?.('.kb-desktop-details');

    if (!details) return;

    cancelClose();

    if (details.contains(event.relatedTarget)) return;

    document
      .querySelectorAll('.kb-desktop-details[open]')
      .forEach((other) => {
        if (other !== details) closeMenu(other);
      });

    openMenu(details);
  });

  document.addEventListener('pointerout', (event) => {
    if (!desktop.matches || event.pointerType !== 'mouse') return;

    const details = event.target.closest?.('.kb-desktop-details');

    if (!details) return;

    if (details.contains(event.relatedTarget)) return;

    cancelClose();

    closeTimer = setTimeout(() => {
      closeMenu(details);
      closeTimer = null;
    }, CLOSE_DELAY);
  });

  document.addEventListener('focusin', (event) => {
    if (event.target.closest?.('.kb-desktop-details')) {
      cancelClose();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      cancelClose();
    }
  });
})();
